import type { FetchProcessDetailsResponseData } from 'gcs-common/clients/api/entities/processes/processes-api-helpers';
import FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import { convertQuantityToString } from 'gcs-common/helper/processTextHelper';
import { getHasFeatureFlag } from 'gcs-common/slices/currentUser/currentUserSelectors';
import { useSelector } from 'react-redux';
import reactStringReplace from 'react-string-replace';
import styles from './styles.module.scss';

interface ProductListItemProps {
  product: FetchProcessDetailsResponseData['items'][number];
  onSelectProduct: VoidFunction;
}

const ProductListItem = (props: ProductListItemProps) => {
  const { product, onSelectProduct } = props;

  const isQuantityEnabled = useSelector(getHasFeatureFlag(FEATURE_FLAGS.PROCESS_QUANTITY_ENABLED));

  if (!product.ArticleNumber) {
    // Remove <br> tags from GC Online Plus; also replace ';' with newline
    const description1RawString = product.ArticleDescription1;
    let description1ReactNode = reactStringReplace(description1RawString, '<br>', () => <br />);
    description1ReactNode = reactStringReplace(description1ReactNode, ';', () => <br />);

    const description2RawString = product.ArticleDescription2;
    let description2ReactNode = reactStringReplace(description2RawString, '<br>', () => <br />);
    description2ReactNode = reactStringReplace(description2ReactNode, ';', () => <br />);

    return (
      <>
        <div className={styles.productTextOnly}>{description1ReactNode}</div>
        <div className={styles.productTextOnly}>{description2ReactNode}</div>
      </>
    );
  }

  const unit = convertQuantityToString(product.QuantityUnit || '');
  const quantityOrderString = (product.QuantityOrder || '').trim();
  const quantityOrderNumber = Number(quantityOrderString.replace(',', '.'));
  const showOrderQuantity = Boolean(
    isQuantityEnabled && quantityOrderString && !Number.isNaN(quantityOrderNumber) && quantityOrderNumber > 0,
  );

  const quantityDeliveredRaw = product.QuantityDelivered;
  const quantityDeliveredString = (quantityDeliveredRaw ?? '').trim();
  const showDeliveredQuantity = Boolean(isQuantityEnabled && quantityDeliveredRaw !== undefined);

  return (
    <button
      type="button"
      onClick={() => onSelectProduct()}
      className={styles.productSmallWrapper}
      data-testid={`process-article-${product.ArticleNumber}`}
      data-testarticlenumber={product.ArticleNumber}
    >
      <div className="flex flex-col gap-4">
        <div className="flex gap-2">
          <div className={styles.productArticleWrapper}>
            <div className={styles.productArticleNumber}>{product.ArticleNumber}</div>
          </div>
          <div className={styles.productDescription}>
            <div>{product.ArticleDescription1}</div>
            <div>{product.ArticleDescription2}</div>
          </div>
        </div>
        {showOrderQuantity || showDeliveredQuantity ? (
          <div className="flex flex-start items-center gap-2">
            {showOrderQuantity ? (
              <div className={`${styles.productQuantity} ${styles.productQuantityOrdered}`}>
                <span className={styles.productQuantityLabel}>Bestellt</span>
                <span className={styles.productQuantityValue}>
                  {quantityOrderString} {unit}
                </span>
              </div>
            ) : null}
            {showDeliveredQuantity ? (
              <div className={`${styles.productQuantity} ${styles.productQuantityDelivered}`}>
                <span className={styles.productQuantityLabel}>Geliefert</span>
                <span className={styles.productQuantityValue}>
                  {quantityDeliveredString} {unit}
                </span>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </button>
  );
};

export default ProductListItem;
